import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const travelPartnerEntity: Entity = {
  model: model,
  repository: repository,
}

export default travelPartnerEntity
